<template>
    <div class="position-box">
        <div 
            class="left-box"
            ref="leftBox"
        >
            <van-sidebar 
                v-model="activeKey"  
                @change="onChange"
            >
                <van-sidebar-item 
                    v-for="(item,index) of setData"
                    :key="index"
                    :title="item.poi_name" />
            </van-sidebar>
        </div>
        <div 
            class="right-box"
            ref="rightBox"
        >
            <div 
                v-for="(item,index) of areaList"
                :key="index"
                :id="`${activeKey}${index}`"
                @click="chooseItem(item,index)"
            >
                <span :class="choosePosition[2]&&choosePosition[2].code==item.code&&'active'">{{item.name}}</span>
                <img 
                    src="@/assets/hotel/img/home/right_cg.png" 
                    alt="right"
                    v-show="choosePosition[2]&&choosePosition[2].code==item.code"
                >
            </div>
        </div>
        
    </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'
    export default {
        props:{
            setData:{//预设数据
                type:Array,
                required:true,
            }
        },
        data() {
            return {
                activeKey: 0,//侧边栏下标
                areaList:[],//右边数据
                choosePosition:[],//被选中
            }
        },
        computed:{
            ...mapState({
                positionActive:state => state.hotel.positionActive
            })
        },
        mounted() {
            if(this.positionActive&&this.positionActive[2]){
                this.activeKey = this.positionActive[0];
                this.choosePosition = this.positionActive;
            }
        },
        methods: {
            ...mapMutations(['setState']),
            onChange(index) {//侧边栏切换
                this.areaList = this.setData[index].poi_list;
                if(this.areaList[0].name!='不限'){
                    this.areaList.unshift({name:'不限',code:0,});
                }
                this.$refs.rightBox.scrollTop=0;
            },
            init(){//初始化
                if(this.positionActive&&this.positionActive[2]){
                    this.choosePosition = this.positionActive;
                    this.activeKey = this.positionActive[0];
                    this.areaList = [...this.setData[this.activeKey].poi_list];
                    if(this.areaList[0].name!='不限'){
                        this.areaList.unshift({name:'不限',code:0,});
                    }
                    setTimeout(()=>{
                        document.getElementById(this.positionActive[1]).scrollIntoView();
                    },1)
                }else{
                    this.areaList = [...this.setData[0].poi_list];
                    if(this.areaList[0].name!='不限'){
                        this.areaList.unshift({name:'不限',code:0,});
                    }
                }
            },
            chooseItem(item,index){//点击确认
                if(item == this.choosePosition[2]){
                    this.choosePosition = [];
                }else{
                    this.choosePosition = [this.activeKey,`${this.activeKey}${index}`,item];
                }
            },
            confirm(){//确认
                this.setState([{name:'positionActive',value:this.choosePosition}]);
                if(this.choosePosition&&this.choosePosition[2]){
                    return this.choosePosition[2];
                }else{
                    return false;
                }
            },
            reset(){//重置
                this.setState([{name:'positionActive',value:[]}]);
                this.activeKey = 0;
                this.choosePosition = [];
                this.init();
            }
        },
        watch:{
            setData(){
                this.init();
            }
        }
    }
</script>

<style lang="less" scoped>
    .position-box{
        display: flex;
        .left-box{
            width: 9.5rem;
            .van-sidebar{
                width: 100%;
                .van-sidebar-item{
                    padding: 3rem 0 3rem 2rem;
                    background-color: #F4F9F6;
                    font-size: 1.5rem;
                    font-weight: 400;
                    color: #666666;
                    line-height: 2.1rem;
                }
                .van-sidebar-item--select{
                    font-weight: 500;
                    color: #108B30;
                    background-color: #fff;
                    &::before{
                        display: none;
                    }
                }
            }
        }
        .right-box{
            flex: 1;
            padding: 0.5rem 0;
            overflow: hidden;
            overflow-y: scroll;
            height: 40.5rem;
            box-sizing: border-box;
            >div{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 1.5rem 1.8rem 1.5rem 3rem;
                span{
                    width: 20rem;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: 1.5rem;
                    color: #333;
                    line-height: 2.1rem;
                    &.active{
                        color: #108B30;
                    }
                }
                img{
                    width: 1.8rem;
                    height: 1.7rem;
                }
            }
        }
    }
</style>